import styled from "styled-components"

export const FormSliderContainer = styled.div`
    flex: 1;
`